<template>
  <ProductListPagination
    v-if="store.totalPages && store.totalPages > 1"
    class="product-list-pagination"
  >
    <nav class="product-list-pagination__nav">
      <ul class="product-list-pagination__list">
        <li
          class="product-list-pagination__list-item product-list-pagination__list-item--prev"
        >
          <!-- TODO: replace a with nuxt-link -->
          <a
            href="javascript:"
            class="product-list-pagination__link product-list-pagination__link--prev"
            @click.prevent="store.changePage(store.currentPage - 1)"
          >
            <span class="visually-hidden">Prev</span>
          </a>
        </li>
        <li
          v-if="store.currentPage - 2 >= 1"
          class="product-list-pagination__list-item"
        >
          <!-- TODO: replace a with nuxt-link -->
          <a
            href="javascript:"
            class="product-list-pagination__link"
            @click.prevent="store.changePage(store.currentPage - 1)"
          >
            {{ store.currentPage - 2 }}
          </a>
        </li>
        <li
          v-if="store.currentPage - 1 >= 1"
          class="product-list-pagination__list-item"
        >
          <!-- TODO: replace a with nuxt-link -->
          <a
            href="javascript:"
            class="product-list-pagination__link"
            @click.prevent="store.changePage(store.currentPage - 1)"
          >
            {{ store.currentPage - 1 }}
          </a>
        </li>
        <li
          class="product-list-pagination__list-item product-list-pagination__list-item--active"
        >
          <!-- TODO: replace a with nuxt-link -->
          <a
            href="javascript:"
            class="product-list-pagination__link product-list-pagination__link--active"
          >
            {{ store.currentPage }}
          </a>
        </li>
        <li class="product-list-pagination__list-item">
          <!-- TODO: replace a with nuxt-link -->
          <a
            v-if="store.currentPage + 1 <= store.totalPages"
            href="javascript:"
            class="product-list-pagination__link"
            @click.prevent="store.changePage(store.currentPage + 1)"
          >
            {{ store.currentPage + 1 }}
          </a>
        </li>
        <li class="product-list-pagination__list-item">
          <!-- TODO: replace a with nuxt-link -->
          <a
            v-if="store.totalPages && store.currentPage + 2 <= store.totalPages"
            href="javascript:"
            class="product-list-pagination__link"
            @click.prevent="store.changePage(store.currentPage + 2)"
          >
            {{ store.currentPage + 2 }}
          </a>
        </li>
        <li
          class="product-list-pagination__list-item product-list-pagination__list-item--next"
        >
          <!-- TODO: replace a with nuxt-link -->
          <a
            href="javascript:"
            class="product-list-pagination__link product-list-pagination__link--next"
            @click.prevent="store.changePage(store.currentPage + 1)"
          >
            <span class="visually-hidden">Next</span>
          </a>
        </li>
      </ul>
    </nav>
  </ProductListPagination>
</template>
<script setup lang="ts">
import { ProductListPagination } from '@hypercodestudio/basler-components';
import { useProductFilterStore } from '~/stores/productFilterStore/productFilterStore';

const store = useProductFilterStore();
</script>
